/**
 * LoginScreen — экран входа (D11, принудительный Google-вход).
 * Показывается, когда у пользователя нет валидного per-user токена: войти можно только через Google.
 */
import { FC } from 'react';
import { LogIn, KeyRound } from 'lucide-react';

import { startGoogleLogin } from '../shared/auth/userToken';

export const LoginScreen: FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-background p-6">
    <div className="w-full max-w-sm rounded-2xl border border-border bg-card p-8 text-center space-y-6 shadow-xl">
      <div className="flex justify-center">
        <div className="rounded-full bg-primary/10 p-3">
          <KeyRound className="w-7 h-7 text-primary" />
        </div>
      </div>
      <div className="space-y-1">
        <h1 className="text-xl font-semibold">AlgoSys</h1>
        <p className="text-sm text-muted-foreground">Войдите, чтобы продолжить</p>
      </div>
      <button
        type="button"
        onClick={startGoogleLogin}
        className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-primary text-primary-foreground px-4 py-2.5 text-sm font-medium hover:bg-primary/90 transition-colors"
      >
        <LogIn className="w-4 h-4" /> Войти через Google
      </button>
      <p className="text-xs text-muted-foreground">
        Доступ по вашему Google-аккаунту. Данные брокера и агенты — персональные.
      </p>
    </div>
  </div>
);
